export default {
  methods: {
    jump1Step (projectId, projectName) {
      if (projectId) {
        this.$router.push({ path: '/CreatOrderFirst/first', query: { secondProjectId: projectId, projectName } });
      }
    },
    jump2Step (projectId, projectName) {
      if (projectId) {
        this.$router.push({ path: '/creatOrderSecond/second', query: { projectId: projectId, projectName } });
      }
    },
    jump3Step (projectId, projectName) {
      if (projectId) {
        this.$router.push({ path: '/creatOrderThird/third', query: { secondProjectId: projectId, projectName } });
      }
    },
    jump4Step (projectId, projectName) {
      if (projectId) {
        this.$router.push({ path: '/CreatOrderFourth/fourth', query: { projectId: projectId, projectName } });
      }
    }
  }
};
